import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = { class: "p-col" }
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_15 = { class: "p-col" }
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_18 = { class: "p-grid p-mt-4" }
const _hoisted_19 = { class: "p-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "dimension" }, "Dimension", -1)
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "condition" }, "Filter Condition", -1)
const _hoisted_23 = { class: "p-col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "amountValue" }, "Amount Or Value", -1)
const _hoisted_25 = { class: "p-grid p-mb-4" }
const _hoisted_26 = { class: "p-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "condition" }, "Sort By Amount or Value", -1)
const _hoisted_28 = { class: "p-col" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "limit" }, "Limit", -1)
const _hoisted_30 = { class: "p-col" }
const _hoisted_31 = { class: "p-field" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)
const _hoisted_33 = { class: "p-grid p-mb-4" }
const _hoisted_34 = { class: "p-col" }
const _hoisted_35 = { class: "p-field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "reportType" }, "Filter Type", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-file-excel",
              class: "p-button-success px-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dt.exportCSV()))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.searchFilters.dimension) + " " + _toDisplayString(_ctx.searchFilters.reportType.name) + " Performance Report", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          ref: "dt",
          value: _ctx.lists,
          lazy: true,
          scrollable: true,
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders.filter(c => c.field != 'totalAmount'), (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                field: col.field,
                header: col.header,
                key: col.field,
                style: {"width":"18rem"}
              }, null, 8, ["field", "header"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders.filter(c => c.field == 'totalAmount'), (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                header: "Total Amount",
                key: col.field,
                style: {"width":"5rem"},
                field: "totalAmount"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.totalAmount)), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.searchFilters.dimension,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.dimension) = $event)),
                options: _ctx.dimensions,
                optionLabel: "name",
                optionValue: "name"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.searchFilters.condition,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.condition) = $event)),
                options: _ctx.conditions,
                optionLabel: "name",
                optionValue: "value"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_InputNumber, {
                id: "amountValue",
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                modelValue: _ctx.searchFilters.amountValue,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.amountValue) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.searchFilters.sort,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.sort) = $event)),
                options: _ctx.sortList,
                optionLabel: "name",
                optionValue: "value"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_InputNumber, {
                id: "limit",
                modelValue: _ctx.searchFilters.limit,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchFilters.limit) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.reportType,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchFilters.reportType) = $event)),
                  options: _ctx.reportTypes,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "value"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}